/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  HeaderTitle,
  IconButton,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
  TwoColumns,
} from '../../../services/settings/appStyle/global.style';
import { CounponContainer } from './discountCoupon.style';
import {
  Loader,
  Table,
  IconButton as IconButtonWithText,
  DeleteConfirmationModal,
} from '../../../Components/uielements';
import { AddPlusIcon, DeleteIcon } from '../../../Components/icons';
import { IntlMessages } from '../../../helper/langHelper';
import CouponModal from './modal/couponModal';
import { counponDeletion, getCouponList } from '../../../services/bioplus-services/discountCoupon';

const PartnerCoupon = () => {
  const [deleteUser, setDeleteUser] = useState();
  const [couponCreation, setCouponCreation] = useState();

  const counponQuery = useQuery('couponList', () => getCouponList());

  const couponTableData = counponQuery?.data?.couponList ?? [];
  const queryClient = useQueryClient();

  const deleteMutation = useMutation((data) => counponDeletion(data?._id), {
    onSuccess: async () => {
      alert('Coupon deleted successfully.');
      await queryClient.invalidateQueries('couponList');
    },
  });

  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.counpan.name" />,
        accessor: 'name',
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.percent.off" />,
        accessor: 'percentOff',
        width: '20%',
        Cell: (cellData) => <TableCell>{`${cellData?.row?.original?.percentOff}%`}</TableCell>,
      },
      {
        Header: <IntlMessages id="table.col.durationInMonths" />,
        accessor: 'durationInMonths',
        width: '20%',
        Cell: (cellData) => (
          <TableCell>
            {cellData?.row?.original?.durationInMonths
              ? `${cellData?.row?.original?.durationInMonths}`
              : '...'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.coupon.type" />,
        accessor: 'duration',
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.actions" defaultMessage="Actions" />,
        accessor: 'actions',
        isAction: true,
        width: '20%',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleDeleteUser = (data) => {
    deleteMutation.mutate(data);
    setDeleteUser(undefined);
  };

  const actionList = [
    (data) => (
      <IconButton onClick={() => setDeleteUser(data)}>
        <DeleteIcon style={{ width: '19px', height: '19px' }} />
      </IconButton>
    ),
  ];

  if (counponQuery.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }
  return (
    <StyledContainer>
      <CounponContainer>
        <HeaderTitle>Discount Coupon</HeaderTitle>
        <TwoColumns style={{ gap: '15px' }}>
          <IconButtonWithText
            text={'Add coupon'}
            icon={<AddPlusIcon />}
            onClick={() => {
              setCouponCreation(true);
            }}
          />
        </TwoColumns>
      </CounponContainer>
      <TableWrapper>
        <Table
          data={couponTableData}
          columns={userColumns}
          hasFooter={false}
          actions={actionList}
        />
      </TableWrapper>

      {deleteUser && (
        <DeleteConfirmationModal
          onClose={() => {
            setDeleteUser(undefined);
          }}
          message={
            <IntlMessages
              id="delete.comfirmation.text.coupon"
              values={{
                coupon: `'${deleteUser?.name}'`,
              }}
            />
          }
          onConfirm={() => handleDeleteUser(deleteUser)}
        />
      )}
      {couponCreation && <CouponModal onClose={() => setCouponCreation(false)} />}
    </StyledContainer>
  );
};

export default PartnerCoupon;
